<img class="logo" [alt]="alt" [ngStyle]="logoStyle" [src]="logoSrc" />
